import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalWindow from '../../../../../../components/ModalWindow';
import {
  formatTime,
  getFromLocalStorage,
} from '../../../../../../global/helpers';
import * as actions from '../../../../../OrdersPage/actions';
import { selectors } from '../../../../../OrdersPage/reducer';
import * as Styled from './CartHistoryModal.styles';

interface CartHistoryModalProps {
  orderId: string;
  createdAt: string;
  onClose: () => void;
}

const parseDescription = (description: string): any[] => {
  try {
    return JSON.parse(description) || [];
  } catch (error) {
    return [];
  }
};

const CartHistoryModal = ({
  orderId,
  createdAt,
  onClose,
}: CartHistoryModalProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const historyData = useSelector(selectors.historyModalData);

  useEffect(() => {
    const token = getFromLocalStorage('accessToken');
    dispatch(actions.getCartHistory.request({ orderId, token, createdAt }));
  }, [dispatch, orderId, createdAt]);

  return (
    <ModalWindow onClose={onClose}>
      {historyData && historyData.length > 0 ? (
        <Styled.HistoryContainer>
          <div className="history-title">
            {t('OrdersPage.CartChangesModal.TITLE')}
          </div>
          {historyData.map((entry: any) => {
            const previous = parseDescription(entry.previous_description);
            const current = parseDescription(entry.current_description);
            const rowsCount = Math.max(previous.length, current.length);

            return (
              <div className="history-entry" key={entry.created_at}>
                <div className="entry-date">
                  {formatTime(entry.created_at, true)}
                </div>
                <div className="columns-header">
                  <div className="column-cell">
                    <span>{t('OrderPage.Collect.History.PRODUCT')}</span>
                    <span>{t('OrderPage.Collect.History.COUNT')}</span>
                  </div>
                  <div className="column-cell">
                    <span>{t('OrderPage.Collect.History.PRODUCT')}</span>
                    <span>{t('OrderPage.Collect.History.COUNT')}</span>
                  </div>
                </div>
                {Array.from({ length: rowsCount }).map((_, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div className="change-row" key={index}>
                    <div className="column-cell">
                      <span>{previous[index]?.name || ''}</span>
                      <span className="cell-count">
                        {previous[index]?.quantity || ''}
                      </span>
                    </div>
                    <div className="column-cell">
                      <span>{current[index]?.name || ''}</span>
                      <span className="cell-count">
                        {current[index]?.quantity || ''}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </Styled.HistoryContainer>
      ) : (
        t('OrdersPage.CartChangesModal.NO_CHANGES')
      )}
    </ModalWindow>
  );
};

export default CartHistoryModal;
